import {
  Accordion,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const MapLegendContainer = styled.div<{ open?: boolean }>`
  display: flex;
  background-color: ${({ theme }) => `${getThemeColor('white', theme)}`};

  position: absolute;
  right: 0px;
  width: 0%;
  height: 100%;
  z-index: 800;
  transition: all 0.3s;

  ${({ open, theme }) =>
    open &&
    `
    width: 300px;
    border-left: 1px solid ${getThemeColor('grey_4', theme)};
    padding: ${getThemeSpacing(2, theme)} ${getThemeSpacing(1, theme)};
    border-bottom-left-radius: ${theme.border_radius.input};
    border-top-left-radius: ${theme.border_radius.input};
    box-shadow: ${theme.box_shadow.card};
  `}
`

export const LegendAccordion = styled(Accordion)`
  box-shadow: none;
`
